import { environments } from '../config/configManager';
import { createHttpClient } from './create-http-client';

const client = createHttpClient({
  baseURL: environments.tmed,
  getAuthHeaders: () => {
    const accessToken = localStorage.getItem('token');
    return accessToken ? { Authorization: accessToken } : {};
  },
  afterSuccess: () => {},
  afterError: () => {},
});

export default client;
